import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteMachineGroup, getMachineGroup } from "../../../actions/machine-group/machine-group";
import MachineGroupListComponent from "../../../components/Definition/MachineGroup/MachineGroupListComponent";

export default function MachineGroupScreen() {
    const [groups, setGroup] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getMachineGroup(params.toString());
                setLoading(false);
                setGroup(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <MachineGroupListComponent lists={groups} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید گروه دستگاه حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteMachineGroup(id);
                    if (response.status === "success") {
                        toast.success("گروه دستگاه حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف گروه دستگاه");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
